import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const { setLang } = useI18n();

  const applyUser = useCallback(
    (u) => {
      setUser(u);
      if (u?.lang) setLang(u.lang);
    },
    [setLang]
  );

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      applyUser(data);
      return data;
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        applyUser(data);
        return data;
      } catch {
        setUser(false);
        return false;
      }
    }
  }, [applyUser]);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refreshMe();
  }, [refreshMe]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser: applyUser, refreshMe, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
